import { useUserQuery } from "../common/lib/fetch";
import { QueryOptions } from "../common/lib/fetch/useQuery";
import { useUser } from "../userAccess/useUser";

export enum StagedPurchaseOrderStep {
    ReceivingCheckIn = "ReceivingCheckIn",
    ReceivingGross = "ReceivingGross",
    ReceivingBayDirections = "ReceivingBayDirections",
    ReceivingTare = "ReceivingTare",
    ReceivingSignature = "ReceivingSignature",
    ReceivingTicketInstructions = "ReceivingTicketInstructions",
}

export interface StagedPurchaseOrderDetails {
  id: string;
  purchaseOrderNumber: string;
  userEmail: string;
  driverNumber: string;
  step: StagedPurchaseOrderStep;
  supplier: string;
  product: string;
  requested: number;
  bay: string;
  createdAt: string;
  locked: boolean;
}

export const useGetStagedPurchaseOrders = (options?: QueryOptions<StagedPurchaseOrderDetails[]>) => {
  const user = useUser();

  return useUserQuery<StagedPurchaseOrderDetails[]>({
    path: `/api/sites/${user.selectedSite?.id}/stagedPurchaseOrders`,
  }, options);
}
